<template>
   <main id="event_body">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          이벤트 상세
        </h1>
      </div>
      <div class="div_padding"></div>
      <event-banner-form :bannerImg="bannerImg"></event-banner-form>
      <div class="eventInfo_wrapper">
        <div class="talk_list">
          <!-- per talk -->
          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 내용</p>
                <p class="text" v-html="eventDesc.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 기간</p>
                <p class="text">
                  {{ eventDate }}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 참여방법</p>
                <p class="text" v-html="eventHowto.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">당첨자 발표</p>
                <p class="text">
                  {{ eventWinnerOpenDateTime }}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">당첨자 조건</p>
                <p class="text" v-html="winnerCondition.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  </main>
</template>

<script>
import EventBannerForm from './common/EventBannerForm.vue'
import { fetchEventDetail } from '@/api/event'
export default {
  components: {
    EventBannerForm
  },
  created() {
    fetchEventDetail({
      nttId: this.$route.query.nttId
    })
    .then(({ data }) => {
      let result = data.result
      if(result.status == 'END') {
        this.$router.push({
          path: '/endedEvent',
          query: {
            nttId: this.$route.query.nttId
          }
        })
      }
      this.joinCnt = result.joinCnt
      this.eventTitle = result.eventTitle
      this.eventDesc = result.eventDesc
      this.eventGift = result.eventGift;
      this.eventHowto = result.eventHowto;
      this.eventDate = result.eventDate;
      this.eventWinnerOpenDateTime = result.eventWinnerOpenDateTime;
      this.winnerCondition = result.winnerCondition;
      this.endTime = result.endTime
      this.bannerImg = result.eventImage

      var url = "/ongoingEvent";
      switch(result.status){
        case "ING": {
          url = "/ongoingEvent"; 
          this.$router.replace({
            path: url,
            query: { nttId: result.nttId },
          });
          break;
        }
        case "READY":{
          url = "/upcomingEvent";
          
          break;
        }
        case "END":{
          url = "/endedEvent";
          this.$router.replace({
            path: url,
            query: { nttId: result.nttId },
          });
          break;
        }
      }

    })
    .then(() => {
    })
  },
  data() {
    return {
      joinCnt: 0,
      eventTitle: '',
      eventGift: '',
      eventHowto: '',
      eventDate: '',
      eventWinnerOpenDateTime: '',
      eventDesc:'',
      winnerCondition: '',
      endTime: '',
      bannerImg: ''

    }
  },
}
</script>

<style  scoped>
.eventInfo_wrapper {
  padding: 0 0 30px 30px;
  background-color: white;
}
.eventInfo_wrapper p {
  font-weight: bold;
}
.eventInfo_wrapper > p {
  margin-right: 30px;
}
.eventInfo_wrapper p span {
  color: var(--Main-color);
  padding-left: 5px;
}
.eventInfo_wrapper .talk_box {
  margin: 20px 30px 0px 0;
  border-radius: 1.681vw;
  background-color: white;
  height: 50px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
}
.eventInfo_wrapper .talk_box textarea {
  border-radius: 1.681vw;
  box-sizing: border-box;
  border: none;
  width: 77%;
  height: 100%;
  resize: none;
  padding: 15px;
}
.eventInfo_wrapper .talk_list .talk_div {
  padding: 20px 20px 20px 0;
  border-bottom: 0.266vw solid var(--Gray-Border);
  display: flex;
}
.eventInfo_wrapper .talk_list .talk_div .profile_pic {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
  flex-shrink: 0;
  flex-grow: 0;
}
.eventInfo_wrapper .talk_list .talk_div .text_box {
  flex-grow: 1;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div {
  width: 100%;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div p {
  width: 100%;
  font-size: 0.75em;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div p span {
  padding-left: 0;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div p .time {
  color: #9ea3ab;
  font-weight: normal;
  float: right;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div .text {
  font-size: 14px;
  font-weight: normal;
  padding-top: 6px;
  letter-spacing: -0.02em;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div .subject {
  color: #9EA3AB;
  font-size: 12px;
}
.eventInfo_wrapper .talk_more {
  width: 100%;
  padding: 20px 30px 20px 0;
  text-align: center;
  font-size: 0.75em;
}
</style>